import SnapshotComparison from '../components/SnapshotComparison/SnapshotComparison';
import SnapshotComparisonDetail from '../components/SnapshotComparison/SnapshotComparisonDetail';

const SNAPSHOT_COMPARISON_ROUTES = [
  {
    id: 'snapshotComparison',
    path: '/snapshot-comparison',
    exact: true,
    component: SnapshotComparison
  },
  {
    id: 'snapshotComparisonDetail',
    path: '/snapshot-comparison/:applicationNumber',
    exact: true,
    component: SnapshotComparisonDetail
  }
];

export default SNAPSHOT_COMPARISON_ROUTES;
